export default __webpack_public_path__ + "media/images/react_icons/property/wifi_router-50718a82182f3950b752d597dd6e1884.svg";